import { useEffect } from "react";
import { Form, Input, Select, Row, Col, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";

export default function ProductIdentityForm({
  onFinish,
  initialValues,
  form,
  productCategoryOptions,
  instrumentTypeOptions,
  assetClassOptions,
  issuerTypeOptions,
}) {
  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  return (
    <div>
      <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
        Product Identity & Governance
      </h3>

      <Form layout="vertical" form={form} onFinish={onFinish}>
        {/* Product Code & Name */}
        <Row>
          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Code
                  <Tooltip title="Selects the behavioural template used by the system. All securities and deals linked to this product inherit the same pricing, accrual, accounting, and lifecycle logic.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="productCode"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 44 }} placeholder="GOVT_TBILL_DISC" />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Name
                  <Tooltip title="Used in deal booking, reporting, audit logs, and user interfaces. Mandatory for traceability.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="productName"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 44 }} />
            </Form.Item>
          </Col>
        </Row>

        {/* Product Category */}
        <Row>
          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Category
                  <Tooltip title="Determines reporting buckets, ALM classification, regulatory segmentation, and portfolio aggregation rules.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="productCategory"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={productCategoryOptions}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Instrument Type
                  <Tooltip title="Drives which pricing engine, cashflow generator, and accrual algorithm the system invokes. Primary behavioural switch.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="instrumentType"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={instrumentTypeOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Instrument Type & Asset Class */}
        <Row>
          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Asset Class
                  <Tooltip title="Used by risk, ALM, liquidity, and regulatory modules to aggregate exposures and apply limits or ratios.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="assetClass"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={assetClassOptions}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Issuer Type
                  <Tooltip title="Drives regulatory risk weight assignment, eligibility rules, and capital treatment.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="issuerType"
              rules={[{ required: true }]}

            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={issuerTypeOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Issuer Type & Tradability */}
        <Row>
          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Tradability
                  <Tooltip title="Controls whether secondary market sale transactions are allowed before maturity.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="tradabilityFlag"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={[
                  // { label: "Tradable", value: true },
                  // { label: "Non-Tradable", value: false },
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0 8px" }}>
            <Form.Item
              label={
                <span>
                  Active Flag
                  <Tooltip title="Enables or disables the product for new deal creation while allowing existing positions to mature.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="activeFlag"
              rules={[{ required: true }]}
            >
              <Select
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" />}
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <button type="submit" hidden />
      </Form>
    </div>
  );
}
